

export const CircularProgressContainer = ({ children, ...props }: { children: React.ReactNode;[key: string]: any }) => (
  <div
    {...props}
    style={{
      position: 'relative',
      width: 150,
      height: 150,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '20px 0'
    }}
  >
    {children}
  </div>
); 